<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SectionsMenu',

  computed: {
    ...mapState('menu', ['sectionsMenu']),
    ...mapGetters('menu', ['getActiveSection']),
  },

  methods: {
    scrollToHash(event) {
      const element = document.getElementById(event.target.value);

      if (!element) {
        return;
      }

      element.scrollIntoView({
        behavior: 'smooth',
      });
    },
  },
};
</script>

<template>
  <div class="sections-menu-mobile" v-if="sectionsMenu">
    <select class="select" @change="scrollToHash($event)" aria-label="Page sections">
      <option
        v-for="option in sectionsMenu"
        :key="option.tagId"
        :value="option.tagId"
        :selected="getActiveSection === option.tagId"
      >
        {{ option.heading }}
      </option>
    </select>
  </div>
</template>

<style lang="scss" scoped>
.sections-menu-mobile {
  .select {
    @include input-field-select;
    padding: $space-12 0;
    border: none;
    background-color: transparent;
    background-position: right 0 center;
    color: $text-color-secondary;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    padding-right: $space-20;
    //Font size must be 16px at least to avoid zooming in on iPhone, this is a fix.
    transform: scale(0.875);
    transform-origin: left;

    &::-ms-expand {
      display: none;
    }
  }

  .svg-icon {
    fill: $interaction-color-tertiary;
  }

  @include desktop-small {
    display: none;
  }
}
</style>
